import Formula from './Formula';
import Unit from './Unit';
import One from './One';

import { RuleExecutor, BotLeft, BotRight } from '../Rule';
import Statement from '../Statement';

import { Vector } from 'prelude-ts';

/**
 * The unit for `Par`.
 */
class Bottom extends Unit {
  negated(): Formula {
    return new One();
  }

  equals(that: Formula): boolean {
    return that instanceof Bottom;
  }

  protected getSymbol(): string {
    return '⊥';
  }

  protected onClick(subgoal: Statement, executor: RuleExecutor) {
    const condL = (stmt: Statement) => {
      return (
        stmt.resources.equals(Vector.of(this)) && stmt.requirements.isEmpty()
      );
    };

    const condR = (stmt: Statement) => {
      return stmt.hasRequirement(this.id);
    };
    if (condL(subgoal)) {
      // This action is disabled when `cond` does not hold, but we sill
      // use a `When` to reassert the condition just in case React asynchrony
      // messes us up.
      return () => executor(new BotLeft(this, condL));
    } else if (condR(subgoal)) {
      return () => executor(new BotRight(this, condR));
    }
  }
}

export default Bottom;
